/**
 * Content objects that contain video metadata (Content, Short, etc.)
 */

/**
 * Standardized video metadata for AI features (Quiz Me, Summarization, Adapt to Industry)
 */

/**
 * Extracts and normalizes video metadata from content objects.
 * Standardizes field names and formats for use across different content types.
 *
 * @param content - Content object with video metadata. If undefined, returns all undefined fields.
 * @returns Normalized metadata with consistent field names and types
 */
export const extractVideoMetadata = content => {
  if (!content) {
    return {
      contentPortalId: undefined,
      outputLanguage: undefined,
      videoId: undefined
    };
  }
  return {
    contentPortalId: content.hubId || content.portalId,
    outputLanguage: content.language ? content.language.toUpperCase() : undefined,
    videoId: content.reference ? Number(content.reference) : undefined
  };
};

/**
 * Content objects that can generate tracking properties (extends VideoMetadataSource)
 */

/**
 * Tracking properties sent to analytics for AI feature interactions
 */

/**
 * Builds standardized tracking properties from content objects.
 * Works with both Lesson Content and Short Content.
 *
 * @param content - Content object (can be undefined)
 * @param contentType - 'VIDEO' for lessons, 'SHORT_FORM_CONTENT' for shorts
 * @param contentId - Content ID
 * @param professorId - Array of professor IDs
 */
export const buildInteractiveContentTrackingProps = (content, contentType, contentId, professorId) => {
  var _content$businessObje, _content$subCategorie, _content$useCases;
  if (!content) {
    return {
      contentType,
      id: contentId,
      professorId
    };
  }
  return {
    businessObjectives: (_content$businessObje = content.businessObjectives) !== null && _content$businessObje !== void 0 ? _content$businessObje : undefined,
    contentLanguage: content.language,
    contentType,
    creatorHubId: content.hubId,
    // Handle both naming conventions - convert arrays to string[] if needed
    hsSoftwareFilters: Array.isArray(content.hubSpotSoftwareTools) ? content.hubSpotSoftwareTools : Array.isArray(content.hsSoftwareFilters) ? content.hsSoftwareFilters : undefined,
    id: contentId,
    name: content.name,
    professorId,
    subCategory: (_content$subCategorie = content.subCategories) !== null && _content$subCategorie !== void 0 ? _content$subCategorie : undefined,
    useCases: (_content$useCases = content.useCases) !== null && _content$useCases !== void 0 ? _content$useCases : undefined
  };
};